import { useInfiniteQuery, InfiniteQueryConfig } from "react-query";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { onError } from "src/Helpers";

export const fetcher = async (
  url: string,
  cursor: any = "",
  headers: AxiosRequestConfig["headers"],
  config: AxiosRequestConfig
) => {
  const userString = localStorage.getItem("user");
  const user = JSON.parse(userString ?? '{}');
  const idToken = localStorage.getItem(user.keyPrefix + '.' + user.username + '.idToken');
  return await axios.request({
    url: url + cursor,
    ...config,
    headers: {
      ...config?.headers,
      ...headers,
      'X-COG-ID': idToken,
    },
  });
};

function useApiFetchInfinite(
  queryKeys: [
    string,
    number?,
    AxiosRequestConfig["headers"]?,
    AxiosRequestConfig?
  ],
  queryConfig?: InfiniteQueryConfig<AxiosResponse<any>, unknown> | undefined,
  fetcherFn: any = fetcher
) {
  return useInfiniteQuery(queryKeys, fetcherFn, {
    onError,
    ...queryConfig,
  });
}

export default useApiFetchInfinite;

// Usage

// const {data, status, error} = useApiFetchInfinite(['/users?page=2']);

// console.log(data);
// console.log(status);
// console.log(error);
